import dayjs from 'dayjs';

export const now = (): dayjs.Dayjs =>
{
    return dayjs();
};
